const base = "cui-card-3imn";
const mega = "cui-card-mega-qnaj";
const giga = "cui-card-giga-jphr";
const classes = {
  base,
  mega,
  giga
};
export {
  base,
  classes as default,
  giga,
  mega
};
